import { object, number, string } from 'yup';
import { IIdNamePair } from '../../../../components/MultiSelectPicker';

export const IdNamePairErrorModel = object<IIdNamePair>({
  id: number().required(),
  name: string().trim().required()
});
